import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import i18n from 'modules/core/lib/i18n'

import TooltipIcon from 'modules/shift_management/components/ShiftManagement//TooltipIcon'
import type ShiftTemplate from 'modules/shift_management/store/api/models/ShiftTemplate'

export interface Props {
  field: Field
  shiftTemplates: ShiftTemplate[]
  onChange: () => void
}

const TemplatePicker = ({ field, shiftTemplates, onChange }: Props) => {
  const [name, setName] = React.useState<string>('')

  const onSelectEmpty = () => {
    field.set('')
    setName('')
  }

  function getLabel(template: ShiftTemplate) {
    const weekCount = template.activeWeeks.length
    const labelName = template.attributes.name

    const labelParams = {
      name: labelName,
      count: weekCount,
    }

    return i18n.tp('shift_management.rotating_shifts.modal_options', labelParams)
  }

  const onSelectTemplate = (id: number | string) => {
    const template = shiftTemplates.find((template) => template.id === id)

    if (!template) throw new Error(`Template with id ${id} not found`)

    field.set(id)
    setName(getLabel(template))

    onChange()
  }

  const data = shiftTemplates.map((template) => ({
    value: template.attributes.id,
    label: getLabel(template),
  }))

  return (
    <Box flexDirection="row" gap="s16" justifyContent="center" alignItems="center" width="full">
      <TooltipIcon.Medium
        icon="shift-management"
        label={i18n.t('shift_management.actions_sidepanel.tooltip.rotating_shift')}
        color="grey700"
      />
      <Box width="full">
        <DropdownSearchBar
          data={data}
          name={name || i18n.t('common.select')}
          hideLabel
          label={i18n.t('shift_management.rotating_shifts.section_title')}
          onSelectEmpty={onSelectEmpty}
          onSelect={(item) => onSelectTemplate(item.value)}
          labelNotFound={i18n.t('shift_management.rotating_shifts.not_found')}
          description={i18n.t('shift_management.rotating_shifts.modal_desc')}
          searchLabel={i18n.t('common.search')}
          sortLabel={i18n.t('common.name')}
          selectLabel={i18n.t('common.select')}
        />
      </Box>
    </Box>
  )
}

export default observer(TemplatePicker)
